import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Checkbox, TextInput, Icon } from '@bwoty-web/ui-kit';
import { UI_CROSS_CIRCLE as IconClear } from '@bwoty-web/ui-kit/icons';

const FilterSettings = styled.div`
  background: var(--color-background-surface-primary);
  padding: var(--space-500);
  box-shadow: var(--elevation-100);
  border-radius: var(--border-radius-500);
`;
const FilterSettingsOption = styled.div`
  margin-top: var(--space-400);
`;

const AutoSuggestContainer = styled.div`
  position: relative;
`;

const AutoSuggestClear = styled.button`
  display: inline;
  position: absolute;
  right: 10px;
  top: 14px;
  background: none;
`;

const Filters = ({ tableLayout, viewSettings, handleViewSettings }) => {
  const handleSearch = (e) => {
    const searchPhrase = e.target.value;
    handleViewSettings((prevState) => ({
      ...prevState,
      searchOpponent: searchPhrase,
    }));
  };

  const handleClear = () => {
    handleViewSettings((prevState) => ({ ...prevState, searchOpponent: '' }));
  };

  const handleChangeHideSoldout = () => {
    handleViewSettings((prevState) => ({
      ...prevState,
      hideSoldout: !viewSettings.hideSoldout,
    }));
  };
  const handleChangeHidePast = () => {
    handleViewSettings((prevState) => ({
      ...prevState,
      hidePast: !viewSettings.hidePast,
    }));
  };

  return (
    <FilterSettings>
      <h3>{tableLayout.filter || 'tableLayout.filter'}</h3>
      <FilterSettingsOption>
        <AutoSuggestContainer>
          <TextInput
            name="Search opponent"
            id="searchOpponent"
            type="text"
            placeholder={tableLayout.searchOpponent || 'tableLayout.searchOpponent'}
            value={viewSettings.searchOpponent}
            onChange={handleSearch}
            autoComplete="off"
          />
          <AutoSuggestClear onClick={handleClear}>
            <Icon size="xs" path={IconClear} />
          </AutoSuggestClear>
        </AutoSuggestContainer>
      </FilterSettingsOption>
      <FilterSettingsOption>
        <Checkbox
          uniqueId="hideSoldout"
          checked={viewSettings.hideSoldout}
          onChange={handleChangeHideSoldout}
        >
          {tableLayout.hideSoldout || 'tableLayout.hideSoldout'}
        </Checkbox>
      </FilterSettingsOption>
      <FilterSettingsOption>
        <Checkbox
          uniqueId="hidePast"
          checked={viewSettings.hidePast}
          onChange={handleChangeHidePast}
        >
          {tableLayout.hidePast || 'tableLayout.hidePast'}
        </Checkbox>
      </FilterSettingsOption>
    </FilterSettings>
  );
};

Filters.propTypes = {
  labels: PropTypes.shape({
    tableLayout: PropTypes.shape({
      filter: PropTypes.string,
      searchOpponent: PropTypes.string,
      hideSoldout: PropTypes.string,
      hidePast: PropTypes.string,
    }),
  }),
  viewSettings: PropTypes.shape({
    searchOpponent: PropTypes.string,
    hidePast: PropTypes.bool,
    hideSoldout: PropTypes.bool,
  }),
  handleViewSettings: PropTypes.func,
}.isRequired;

export default Filters;
